'use client';

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createAPhysicalCard } from '../../services/cardService';
import {
  TCreatePhysicalCardPayload,
  TCreatePhysicalCardResponse,
} from '../../types/cards/card-types';
import { TErrorResponse } from '../../types/error/error-response';

const useCreateAPhysicalCard = () => {
  const queryClient = useQueryClient();
  
  const { data, mutate, isPending, error, isSuccess, isError } = useMutation<
    TCreatePhysicalCardResponse,
    TErrorResponse,
    TCreatePhysicalCardPayload,
    unknown
  >({
    mutationKey: ['create-physical-card'],
    mutationFn: (payload) => createAPhysicalCard(payload),
    onSuccess: () => {
      // Invalidate all card-related queries to refresh the UI
      queryClient.invalidateQueries({ queryKey: ['get-cards'] });
      queryClient.invalidateQueries({ queryKey: ['get-card-batches'] });
      queryClient.invalidateQueries({ queryKey: ['transactions'] });
    },
  });

  return { data, mutate, isPending, error, isSuccess, isError };
};

export default useCreateAPhysicalCard;
